import { render, staticRenderFns } from "./DynamicFormFields.vue?vue&type=template&id=81403978&scoped=true&"
import script from "./DynamicFormFields.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFields.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormFields.vue?vue&type=style&index=0&id=81403978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81403978",
  null
  
)

export default component.exports